import { Typography } from "@mui/material";
import React, {useEffect, useState} from "react";

import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";

import HeaderHome from "../../components/layout/HeaderHome";
import Breadcrumb from "../../components/seller-store/Breadcrumb";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";

const PrivacyPolicy = () => {

  return (
    <>
              {/* ColorInit */}
              <ColorInit color={false} />
        
              {/* ScrollToTop */}
              <ScrollToTop smooth color='#990A02' />
        
              {/* Preloader */}
              <Preloader />
        
              {/* HeaderTwo */}
              {/* <HeaderOne /> */}
              <HeaderHome />

        <div className="container-sm">
        <Typography className="my-30">
                
<div className="text-center">Payment Policy</div>
<br />
1. Seller Community Fees<br />
Membership fees are charged in advance and grant access to the benefits associated with the selected membership tier. Fees may be billed on a monthly, quarterly, or annual basis, depending on the plan chosen at enrollment.<br />
<br />
2. Payment Methods<br />
We accept approved payment methods such as credit/debit cards, bank transfers, or other electronic payment options as made available at the time of purchase. All payments must be made in the currency specified during checkout.<br />
<br />
3. Automatic Renewals<br />
Memberships are set to automatically renew at the end of each billing cycle unless canceled prior to the renewal date. By enrolling, members authorize us to charge the payment method on file for recurring membership fees.<br />
<br />
4. Failed or Late Payments<br />
If a payment fails or is declined, we may attempt to process the payment again. Access to membership benefits may be suspended until payment is successfully completed. Continued non-payment may result in membership termination.<br />
<br />
5. Cancellations<br />
Members may cancel their membership at any time through their account settings or by contacting customer support. Cancellations will take effect at the end of the current billing period unless otherwise stated.<br />
<br />
6. Refund Policy<br />
Membership fees are non-refundable except where required by law or explicitly stated in a promotional offer or written agreement. No partial refunds will be issued for unused time or benefits.<br />
<br />
7. Price Changes<br />
We reserve the right to modify membership pricing at any time. Members will be notified in advance of any pricing changes, which will take effect at the next billing cycle.<br />
<br />
8. Taxes<br />
Applicable taxes may be added to membership fees based on local laws and regulations.<br />
<br />
9. Policy Updates<br />
This payment policy may be updated from time to time. Continued use of the membership program constitutes acceptance of the revised policy.<br />
<br />
        </Typography>
        </div>
        

        {/* FooterTwo */}
              <FooterOne />
        
              {/* BottomFooter */}
              <BottomFooter />
              
    </>
  );
};

export default PrivacyPolicy;